import * as Yup from 'yup';

export const formSchema = [
  {
    name: 'amount',
    validate: Yup.number().typeError('Số điểm không hợp lệ'),
  },
];

export const formSchemaPinCode = [
  {
    name: 'pinCode',
    validate: Yup.number()
      // .typeError('Mật khẩu phải là số')
      .test(
        'len',
        'Mật khẩu phải có ít nhất 6 kí tự',
        (val) => (val?.toString().length ?? 0) >= 6,
      ),
  },
];
